import axios from 'axios';

/**
 * Cliente centralizado para la API de FastAPI
 */
const apiClient = axios.create({
  // URL base configurable para producción en React.js
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://localhost:4443/api',
  withCredentials: true,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  }
});

export const apiRequest = (config = {}) => {
  return apiClient(config);
};

/**
 * Interceptor para Seguridad
 */
apiClient.interceptors.request.use(
  (config) => {
    // 1. Intentar obtener el token de múltiples fuentes
    const token = process.env.REACT_APP_API_TOKEN; // React.js usa REACT_APP_*

    if (token && token !== "undefined") {
      config.headers.Authorization = `Bearer ${token.trim()}`;
      // Log para confirmar que el token se está enviando (solo en desarrollo)
      console.log(`🚀 Petición enviada a: ${config.url} con Token.`);
    } else {
      console.error("❌ ERROR: No hay API_TOKEN. Las peticiones serán rechazadas por el Backend.");
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Interceptor para Errores
 */
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const isCanceled = error.code === 'ERR_CANCELED' || error.name === 'CanceledError' || error.name === 'AbortError' || axios.isCancel?.(error);
    if (isCanceled) {
      // No logueamos una cancelación de petición como error real.
      return Promise.reject(error);
    }

    if (!error.response) {
      console.error("🌐 Error de Red: El servidor no responde o hay un bloqueo de CORS.");
    } else {
      console.error(`🚫 Error ${error.response.status}:`, error.response.data?.detail || error.message);
      
      if (error.response.status === 401) {
        console.warn("🔑 Token inválido o expirado.");
      }
      if (error.response.status === 500) {
        console.error("🔥 Error interno del servidor (posible error en query DuckDB).");
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;